import { Fragment } from "react";
import { Grid as MuiGrid } from "@mui/material";

import { StyledEmptyWrapper } from "@framework/styled";
import { IAssetPromo } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";

import { AssetPromoItem } from "./item";

export const AssetPromoList = () => {
  const { isLoading, allRows } = useFetchQuery<IPaginationResult<IAssetPromo>>("/promos");

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "promo-list"]} />

      <PageHeader message="pages.promo-list.title" />

      <ProgressOverlay isLoading={isLoading}>
        <MuiGrid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(promo => (
              <MuiGrid size={{ lg: 4, sm: 6, xs: 12 }} key={promo.id}>
                <AssetPromoItem promo={promo} />
              </MuiGrid>
            ))}
          </StyledEmptyWrapper>
        </MuiGrid>
      </ProgressOverlay>
    </Fragment>
  );
};
